export default "__VITE_ASSET__BSkK4D1$__"